import { ThemeOptions } from '@mui/material';

import { cssVars } from '../../../utils/cssVars';

import { tokens } from '../../../theme/generated/tokens';

const { getters, setValues } = cssVars(
  {
    size: undefined,
  },
  'ds-chart-indicator'
);

export const chartIndicatorTheme: ThemeOptions['components'] = {
  DsChartIndicator: {
    defaultProps: {
      size: 'small',
      variant: 'filled',
    },
    styleOverrides: {
      small: setValues({
        size: '8px',
      }),
      large: setValues({
        size: '12px',
      }),
      root: {
        display: 'inline-flex',
        borderRadius: tokens.theme.radius.xs,
        width: getters.size(),
        minWidth: getters.size(),
        height: getters.size(),
        minHeight: getters.size(),
      },
    },
  },
};
